var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFirstTitleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 57,
    viewBox: "0 0 56 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 56,
    height: 56,
    rx: 4,
    fill: "#224B99",
    fillOpacity: 0.1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1,
    width: 55,
    height: 55,
    rx: 3.5,
    stroke: "#224B99",
    strokeOpacity: 0.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35 14H23C21.9391 14 20.9217 14.4214 20.1716 15.1716C19.4214 15.9217 19 16.9391 19 18V38C19 39.0609 19.4214 40.0783 20.1716 40.8284C20.9217 41.5786 21.9391 42 23 42H27.514C27.0046 41.3831 26.564 40.7125 26.2 40H23C22.4696 40 21.9609 39.7893 21.5858 39.4142C21.2107 39.0391 21 38.5304 21 38V37.994H25.412C24.8783 36.1101 24.8571 34.1178 25.3507 32.223C25.8442 30.3282 26.8346 28.5994 28.2196 27.2153C29.6046 25.8311 31.3339 24.8417 33.229 24.3493C35.1242 23.8568 37.1164 23.8792 39 24.414V18C39 16.9391 38.5786 15.9217 37.8284 15.1716C37.0783 14.4214 36.0609 14 35 14ZM23 19H35C35.2652 19 35.5196 19.1054 35.7071 19.2929C35.8946 19.4804 36 19.7348 36 20V22C36 22.2652 35.8946 22.5196 35.7071 22.7071C35.5196 22.8946 35.2652 23 35 23H23C22.7348 23 22.4804 22.8946 22.2929 22.7071C22.1054 22.5196 22 22.2652 22 22V20C22 19.7348 22.1054 19.4804 22.2929 19.2929C22.4804 19.1054 22.7348 19 23 19ZM45 35C45 37.3869 44.0518 39.6761 42.364 41.364C40.6761 43.0518 38.3869 44 36 44C33.6131 44 31.3239 43.0518 29.636 41.364C27.9482 39.6761 27 37.3869 27 35C27 32.6131 27.9482 30.3239 29.636 28.636C31.3239 26.9482 33.6131 26 36 26C38.3869 26 40.6761 26.9482 42.364 28.636C44.0518 30.3239 45 32.6131 45 35ZM33 37.99C33 38.1669 33.0469 38.3407 33.1359 38.4936C33.225 38.6465 33.353 38.773 33.507 38.8602C33.6609 38.9475 33.8352 38.9923 34.0121 38.9901C34.189 38.988 34.3622 38.9389 34.514 38.848L39.514 35.854C39.6623 35.7652 39.7851 35.6395 39.8703 35.4891C39.9555 35.3388 40.0004 35.1689 40.0004 34.996C40.0004 34.8231 39.9555 34.6532 39.8703 34.5029C39.7851 34.3525 39.6623 34.2268 39.514 34.138L34.514 31.144C34.3624 31.0531 34.1894 31.0041 34.0126 31.0019C33.8359 30.9996 33.6617 31.0443 33.5078 31.1313C33.354 31.2183 33.2259 31.3445 33.1367 31.4971C33.0475 31.6497 33.0003 31.8232 33 32V37.99Z",
    fill: "#224B99"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirstTitleIcon);
export default __webpack_public_path__ + "static/media/first-title-icon.c90ee4b8eaa7e0816b1be5d47327c2a3.svg";
export { ForwardRef as ReactComponent };